export default "__VITE_ASSET__9025ea3c__"